import { Channel, Workspace } from '@/types/workspace';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';





export const userIdAtom = atom<string | null>(null);
export const activeWorkspaceIdAtom = atomWithStorage<string | null>(
    'activeWorkspaceId',
    null
);
export const activeWorkspaceAtom = atomWithStorage<Workspace | null>(
    'activeWorkspace',
    null
);
export const activeChannelAtom = atomWithStorage<Channel | null>(
    'activeChannel',
    null
);
export const activePathAtom = atomWithStorage<string | null>(
    'activePath',
    null
);
export const activeSideBarAtom = atomWithStorage<string | null>(
    'activeSideBar',
    null
);

export const headerAtom = atom<{ one: string; two: string; postFix: string }>({
    one: '',
    two: '',
    postFix: '',
});

export const playbookUrlAtom = atomWithStorage<string | null>(
    'playbookUrl',
    '/playbooks/playbook-blank.md'
);

export const DEFAULT_PLAYBOOK_ACTION_ITEMS = [
    {
        id: 1,
        title: 'Share LinkedIn promotion assets with partners',
        description: 'Share LinkedIn promotion assets with partners',
        completed: false,
        status: 'none',
    },
    {
        id: 2,
        title: 'Coordinate cross-partner email blast',
        description: 'Coordinate cross-partner email blast',
        completed: false,
        status: 'none',
    },
    {
        id: 3,
        title: 'Send reminder to top prospects',
        description: 'Send reminder to top prospects',
        completed: false,
        status: 'none',
    },
];


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const playbookActionItemsAtom = atomWithStorage<any[]>(
    'playbookActionItems',
    DEFAULT_PLAYBOOK_ACTION_ITEMS
);